import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  // Focus ring removed — index.css owns the single global :focus-visible outline.
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow-xs",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow-xs",
        outline: "border-border-strong bg-card text-muted-foreground",
        success: "border-transparent bg-[hsl(var(--fc-emerald)/0.14)] text-[hsl(var(--fc-emerald-ink))]",
        warning: "border-transparent bg-[hsl(var(--fc-warning)/0.16)] text-[hsl(26_86%_29%)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
